import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

const init = async (block) => {
    const reversed = block.classList.contains('parallax-reversed');
    return new Promise((resolve) => {
        ScrollTrigger.matchMedia({
            '(min-width: 1024px)': function () {
                let gsapElement = gsap.timeline({
                    scrollTrigger: {
                        trigger: block,
                        start: 'top bottom',
                        end: () => 'bottom top',
                        scrub: true,
                        // markers: true,
                        toggleActions: "play none none none"
                    }
                })

                gsapElement.fromTo(block, {
                    y: reversed ? '3%' : '-4%'
                }, {
                    y: reversed ? '-6%' : '4%'
                })
            }
        })

        return resolve('Parallax loaded')
    })
}

export { init }
